import { SUPPORT_STATUS, SUPPORT_STATUS_CTA_LABEL, SUPPORT_STATUS_TITLE } from 'app-constants'
import { AICard } from 'components/ai-card'
import { useDispatch } from 'react-redux'
import { STATICS } from 'statics'
import { sendWhatsappMessage } from 'utils'
import './style.scss'

export function NoMatchingRule({ data }) {
  const { detailedMessage } = data
  const dispatch = useDispatch()

  function handleCtaTalkAttendantClick() {
    dispatch(sendWhatsappMessage)
  }

  return (
    <div className='support-no-matching-rules'>
      <AICard
        title={SUPPORT_STATUS_TITLE[SUPPORT_STATUS.NO_MATCHING_RULE]}
        message={detailedMessage}
        ctaLabel={SUPPORT_STATUS_CTA_LABEL.TALK_WITH_ATTENDANT}
        onCtaClick={handleCtaTalkAttendantClick}
        icon={
          <div className='icon'>
            <STATICS.INFO_TRIANGLE_FILLED />
          </div>
        }
      />
    </div>
  )
}
